export default __webpack_public_path__ + "static/media/duplicate.4662b83b.png";